<template>
  <div class="home-menu">
    <ComingSoon v-bind:msg="comingSoonMsg" />

    <div class="columns is-mobile">
      <div class="column">
        <!-- <router-link to="/tuktuk" v-ripple> -->
        <a @click="goToTransport">
          <img src="../assets/home_menu_transport120.png" />
        </a>
        <!-- </router-link> -->
        <p class="button-name">{{ $t("home.transport-button") }}</p>
      </div>
      <div class="column">
        <!-- disabled for normal users -->
        <!-- <a :disabled="true" @click="comingSoon" v-show="!$store.getters.isSuperUser" v-ripple>
          <img src="../assets/home_menu_shop120.png" />
        </a>-->
        <!-- super users can access it -->
        <!-- <router-link to="/shop" v-show="$store.getters.isSuperUser" v-ripple> -->
        <router-link to="/shop" v-ripple>
          <img src="../assets/home_menu_shop120.png" />
        </router-link>
        <div class="button-name" @click="toggleShadow">{{ $t("home.shop-button") }}</div>
      </div>
      <div class="column">
        <router-link to="/profile" v-ripple>
          <img src="../assets/home_menu_profile120.png" />
        </router-link>
        <div class="button-name">{{ $t("home.profile-button") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ComingSoon from "@/components/ComingSoon.vue";

export default {
  name: "HomeMenu",
  components: {
    ComingSoon
  },
  data() {
    return {
      comingSoonMsg: this.$t("coming-soon")
    };
  },
  methods: {
    comingSoon() {
      this.$el.querySelector(".coming-soon-modal").classList.add("is-active");
    },
    toggleShadow() {
      // this.$el
      //   .querySelectorAll("img")
      //   .forEach(el => el.classList.toggle("shadow"));
      this.$el.querySelector(".columns").classList.toggle("dark");
    }
  }
};
</script>

<style scoped>
.centered {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0%);
}
.home-menu {
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 130px;
  width: 100vw;
  background-color: white;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  display: flex;
  align-items: center;
  /* overflow-x: auto; */
  overscroll-behavior: contain;
  overflow: hidden;
}
.columns {
  margin: 0;
  left: 0px;
  width: 100%;
  padding-top: 8px;
  /* height: 15vh; */
}
.column {
  /* height: 14vh;
  width: 14vh; */
  margin: 13px;
  padding: 0px;
}
.button-name {
  /* line-height: 2em; */
}
.button {
  /* width: 10vh; */
  /* height: 10vh; */
  /* background-color: #fff8e4; */
  /* background-color: gainsboro; */
  /* filter: drop-shadow(1px 1px 1px #666); */
}
img {
  /* transform: scale(0.7); */
  height: 80px;
  width: 80px;
}
/* .shadow {
  -webkit-filter: drop-shadow(0px 0px 0px #666);
  filter: drop-shadow(0px 0px 0px #666);
} */
.dark {
  /* background-color: darkslategray; */
  background-color: #3173dc;
  color: white;
}
img:active {
  transform: rotate(350deg);
  -webkit-transform: rotate(350deg);
  -ms-transform: rotate(350deg);
}
</style>